import type { StatusPage, StatusPageInput } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

export interface DomainSetup {
  requiredRecords: { type: string; name: string; value: string }[];
}

export const statusPageService = {
  list: (
    tenantId: string,
    params: { limit?: number; startAfter?: string } = {}
  ): Promise<PaginatedResult<WithId<StatusPage>>> =>
    api.getPaginated<WithId<StatusPage>>(
      withTenant('/status-pages', tenantId, params)
    ),

  get: (tenantId: string, id: string): Promise<WithId<StatusPage>> =>
    api.get<WithId<StatusPage>>(withTenant(`/status-pages/${id}`, tenantId)),

  create: (
    tenantId: string,
    input: StatusPageInput
  ): Promise<WithId<StatusPage> & { domainSetup?: DomainSetup }> =>
    api.post(withTenant('/status-pages', tenantId), input),

  update: (
    tenantId: string,
    id: string,
    patch: Record<string, unknown>
  ): Promise<WithId<StatusPage> & { domainSetup?: DomainSetup }> =>
    api.put(withTenant(`/status-pages/${id}`, tenantId), patch),

  remove: (tenantId: string, id: string): Promise<void> =>
    api.delete(withTenant(`/status-pages/${id}`, tenantId)),
};
